import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../models/common/user.model';
import { CorporateEditResponse } from '../models/corporate/corporate-edit-response.model';
import { CorporateImageResponse } from '../models/corporate/corporate-image-response.model';

@Injectable({ providedIn: 'root' })
export class UserService {

  private readonly baseUrl = environment.apiUrl;

  readonly currentUser = signal<User | null>(null);
  readonly hasActivePlan = computed(() => !!this.currentUser()?.corporatePlan?.isActive);

  constructor(private http: HttpClient) { }

  userInfo(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}corporate/user-info`, { withCredentials: true });
  }

  editCorporateName(name: string): Observable<CorporateEditResponse> {
    return this.http.put<CorporateEditResponse>(`${this.baseUrl}corporate/name`, { companyName: name }, { withCredentials: true });
  }

  editCorporateInfo(data: { companyPhone?: string; companyAddress?: string; companyId?: string }): Observable<CorporateEditResponse> {
    return this.http.put<CorporateEditResponse>(`${this.baseUrl}corporate/info`, data, { withCredentials: true });
  }

  editCorporatePhoto(photo: File): Observable<CorporateImageResponse> {
    const formData = new FormData();
    formData.append('photo', photo);
    return this.http.post<CorporateImageResponse>(`${this.baseUrl}corporate/photo`, formData, { withCredentials: true });
  }

  loadUserInfo() {
    return this.userInfo().pipe(
      tap((user: User) => {
        this.currentUser.set(user);
      }),
      catchError(error => {
        console.error('Error loading user info:', error);
        return of(null);
      })
    );
  }

  setTrasactionStatus(status: string) {
    const currentUser = this.currentUser();
    if (currentUser) {
      currentUser.corporatePlan.transactionStatus = status;
      this.currentUser.set(currentUser);
    }
  }
}